export const EXTEND_QUOTA_OFFER_PROPS_MAP = {
    title: 'Места почти не осталось, но есть решение',
    text: 'Ваше Облако почти заполнено. Подключите ещё 512 ГБ — и не придётся что‑то удалять',
    primaryActionText: 'Подключить 512 ГБ со скидкой',
    secondaryActionText: 'Другие тарифы',
};
